var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal-add-trigger", attrs: { id: _vm.id } },
    [
      _c("p", { staticClass: "title" }, [_vm._v("Add Trigger Event")]),
      _vm._v(" "),
      _c(
        "b-form",
        { class: { "error-input": _vm.$v.dataSetup.triggerName.$error } },
        [
          _c("label", [_vm._v("Name")]),
          _vm._v(" "),
          _c("j-input", {
            attrs: {
              "error-required": _vm.$v.dataSetup.triggerName.$error,
              placeholder: "Trigger name"
            },
            model: {
              value: _vm.dataSetup.triggerName,
              callback: function($$v) {
                _vm.$set(_vm.dataSetup, "triggerName", $$v)
              },
              expression: "dataSetup.triggerName"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form",
        { class: { "error-input": _vm.$v.dataSetup.triggerEvent.$error } },
        [
          _c("label", [_vm._v("Event")]),
          _vm._v(" "),
          _c("j-single-select", {
            attrs: {
              "error-required": _vm.$v.dataSetup.triggerEvent.$error,
              options: _vm.eventOptions,
              placeholder: "Select Event Type",
              label: "text"
            },
            model: {
              value: _vm.dataSetup.triggerEvent,
              callback: function($$v) {
                _vm.$set(_vm.dataSetup, "triggerEvent", $$v)
              },
              expression: "dataSetup.triggerEvent"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex justify-content-end mt-4" }, [
        _c(
          "button",
          {
            staticClass: "button-border mr-2",
            on: {
              click: function($event) {
                _vm.$emit("close-modal")
              }
            }
          },
          [_vm._v("\n      Close\n    ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "button-blue", on: { click: _vm.submitTrigger } },
          [_vm._v("\n      Create\n    ")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e196a55", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e196a55","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/data-manager/jModalAddTrigger.vue
// module id = null
// module chunks = 